import { type Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const sxInstallationCard = (isSelected: boolean, isConnectedToMe: boolean, theme: Theme) => ({
  width: '100%',
  p: 2,
  mb: 2,
  borderRadius: 1,
  border: '2px solid',
  borderColor: isSelected ? theme.palette.text.primary : alpha(theme.palette.grey[500], 0.16),
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '&:hover': {
    borderColor: isSelected ? theme.palette.text.primary : alpha(theme.palette.grey[500], 0.32),
  },
});

export const progressSx = { with: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' };

export const countSx = { display: 'inline', fontWeight: 700 };
